(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tipset/assets/javascripts/views/bomben-matches.js') >= 0) return;  svs.modules.push('/modules/tipset/assets/javascripts/views/bomben-matches.js'); 
(function(Backbone, _, svs) {
  svs.tipset.views.BombenMatches = Backbone.Marionette.CollectionView.extend({
    className: 'list-group',
    tagName: 'ul',
    childView: svs.tipset.views.BombenMatch,

    childEvents: {
      childUpdated: 'onChildUpdated'
    },

    initialize: function(params) {
      this.options = params;
    },

    onChildUpdated: function(ev) {
      if (this.children.last().cid == ev.cid) {
        svs.components.Modal.currentView().trigger('modalContentResize');
      }
    }
  });
})(Backbone, _, svs);

 })(window);